import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/bondRecord',
    meta: { title: '保证金充值退还记录' },
    component: Layout,
    redirect: '/bondRecord/list',
    children: [
      {
        path: 'list',
        meta: { title: '保证金充值退还记录', activeMenu: '/bondRecord' },
        component: () => import('@/views/bondRecord/BondRecord.vue')
      },
      {
        path: 'detail',
        meta: { title: '保证金充值退还详情', activeMenu: '/bondRecord' },
        component: () => import('@/views/bondRecord/BondRecordDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增保证金充值退还', activeMenu: '/bondRecord' },
        component: () => import('@/views/bondRecord/BondRecordAdd.vue')
      },
      {
        path: 'quickadd',
        meta: { title: '快捷充值', activeMenu: '/bondRecord' },
        component: () => import('@/views/bondRecord/BondRecordAdd2.vue')
      }

    ]
  },
  {
    path: '/goodsRecord',
    meta: { title: '货款充值退还记录' },
    component: Layout,
    redirect: '/goodsRecord/list',
    children: [
      {
        path: 'list',
        meta: { title: '货款充值退还记录', activeMenu: '/goodsRecord' },
        component: () => import('@/views/goodsRecord/BondRecord.vue')
      },
      {
        path: 'detail',
        meta: { title: '货款充值退还详情', activeMenu: '/goodsRecord' },
        component: () => import('@/views/goodsRecord/BondRecordDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '货款保证金充值退还', activeMenu: '/goodsRecord' },
        component: () => import('@/views/goodsRecord/BondRecordAdd.vue')
      },
      {
        path: 'quickadd',
        meta: { title: '快捷充值', activeMenu: '/goodsRecord' },
        component: () => import('@/views/bondRecord/BondRecordAdd2.vue')
      }

    ]
  }

]
